import { addDoc, collection } from "firebase/firestore";
import { createConversation } from "./conversations";
import { db } from "firebaseApp";
import { popupActions } from "store/react-lib/generic-ui/popup";

export const URL_TYPE = { id: "url", label: "URL" };
export const FILE_TYPE = { id: "file", label: "File" };
export const IMAGE_TYPE = { id: "image", label: "Image" };
export const TEXT_TYPE = { id: "text", label: "Text" };

export async function attachFileToConversation({
  setAttaching,
  botId,
  uid,
  activeConversation,
  fileId,
  fileData,
  dispatch,
  callback = () => {},
}) {
  try {
    setAttaching(true);
    let conversation = activeConversation;
    if (!conversation) {
      conversation = await createConversation(botId, uid, dispatch);
    }
    if (!conversation) {
      return;
    }
    const attachmentRef = await addDoc(collection(db, "attachments"), {
      ...fileData,
      fileId,
      botId,
      conversationId: conversation.id,
    });
    callback({ fileId, fileData });
  } catch (error) {
    console.log(error);
    dispatch(popupActions.showError("Couldn't attach file. Try again later."));
  } finally {
    setAttaching(false);
  }
}
